export default __webpack_public_path__ + "static/media/vk-yellow.e5925e1a.svg";